export default function numberInRange(num: number, min?: number, max?: number) {
  return +Math.min(
    Math.max(num, min ?? Number.MIN_SAFE_INTEGER),
    max ?? Number.MAX_SAFE_INTEGER,
  ).toFixed(6);
}
